import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blog-style-three',
  templateUrl: './blog-style-three.component.html',
  styleUrls: ['./blog-style-three.component.scss']
})
export class BlogStyleThreeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
